export const scrollToPricing = () => {
  const el = document.getElementById('precios')
  if (el) {
    el.scrollIntoView({ behavior: 'smooth' })
  }
}
